import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Lottie from "react-lottie";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import animationData from "../animations/animation.json";
import Text from "../text/Text";
import { logoWithName } from "../images";
import {
  btc,
  happySpending,
  promoCodeClaimed,
  promoCodeReward,
  referFriends,
  sats,
} from "../messages";
import { showAmount } from "../constants";
import { store } from "../../redux/store";

function AppliedPromoCode() {
  const navigate = useNavigate();
  const location = useLocation();
  const [rewardAmount, setRewardAmount] = useState("");
  const [rewardCurrency, setRewardCurrency] = useState("");

  const data = location?.state?.details;

  const showBtcAmount = store.getState()?.common?.showBtcAmount;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    setTimeout(() => {
      navigate("/settings");
    }, 5000);
  }, []);

  useEffect(() => {
    const cashbackAsset =
      data?.benefits_asset_id === sats
        ? showBtcAmount
          ? btc
          : sats
        : data?.benefits_asset_id;

    const cashbackAmount = showAmount({
      amount: data?.cashback_amount,
      currency: data?.benefits_asset_id,
      showCommaSeparated: true,
      targetedCurrency: cashbackAsset,
    });

    setRewardAmount(cashbackAmount);
    setRewardCurrency(cashbackAsset);
  }, [data]);

  return (
    <Box
      className="paid-payment-wrapper"
      sx={{
        backgroundColor: "#F4F5FA",
      }}
    >
      <CloseIcon
        sx={{
          color: "#848B9E",
          height: "24px",
          width: "24px",
          cursor: "pointer",
        }}
        className="close-icon"
        onClick={() => navigate("/settings")}
      />
      <Box
        className="paid-payment-detail"
        height="80%"
        textAlign="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box>
          <Text className="default-text">{promoCodeClaimed[0]}</Text>
          <Text className="default-text">{promoCodeClaimed[1]}</Text>
        </Box>
        <Lottie options={defaultOptions} height="224px" width="224px" />
        <Box>
          <Text margin="12px 0">
            {promoCodeReward(rewardAmount, rewardCurrency)}
          </Text>
          <Text className="grey-text">{happySpending.toUpperCase()}</Text>
        </Box>
        {/* <Text color="primary">{referFriends}</Text> */}
        <img
          src={logoWithName}
          alt="logo"
          style={{
            marginLeft: "12px",
          }}
        />
      </Box>
    </Box>
  );
}

export default AppliedPromoCode;
